import Footer from "@/components/footers/Footer";
import { cn } from "@/lib/utils";

const CenterConatainer: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    return (
        <div className="nk-wrap-nosidebar gs-login-page min-h-screen">
            <div className="nk-split nk-split-page nk-split-lg nk-spl min-h-screen">
                <div
                    className={cn(
                        "nk-block nk-block-middle nk-auth-body relative mx-auto flex min-h-screen w-full max-w-[420px] flex-col justify-center px-4 sm:px-6"
                    )}
                >
                    <div className="LogoForm w-full">{children}</div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default CenterConatainer;
